// extracted by mini-css-extract-plugin
module.exports = {"header":"index-module--header--d4aLU","brandName":"index-module--brandName--PqXNF","link":"index-module--link--Xg7SY"};